import React, { useContext, useEffect, useState, useRef } from "react";
import styles from "./Header.module.scss";
import MobileContext from "../../context/mobile";
import { Link, NavLink } from 'react-router-dom';

const Header = (props) => {
  const { items, style, currentPath } = props;
  const isMobile = useContext(MobileContext);
  const [btns, setBtns] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const refBtns = useRef([]);
  const refNav = useRef(null);
  const refLogo = useRef(null);
  const refWrap = useRef(null);
  const refInner = useRef(null);
  const refBurger = useRef(null);
  const refMenu = useRef(null);
  const refOverlay = useRef(null);
  const refBtnsHiddens = useRef([]);
  const [searchParam, setSearchParam] = useState('');
  useEffect(()=>{
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    searchParams.delete('vacancy_id');
    url.search = searchParams.toString();
    setSearchParam(url.search);
  },[]);
  useEffect(() => {

    const inner = refInner.current;
    const clickHandler = (index) => {
      if (document.querySelector(`[data-stage='${index}']`) !== null) {
        let offsetHeader = inner.offsetHeight + inner.getBoundingClientRect().top * 2;
        let offset = document.querySelector(`[data-stage='${index}']`).getBoundingClientRect().top + window.scrollY - offsetHeader + 1;
        window.scrollTo({
          top: offset,
          behavior: 'smooth',
        });
      }
    }
    if (items !== undefined && !isMobile) {
      let array = [];
      items.forEach((item, index) => {
        let btn = <div className={styles.btn} key={`btn-${index}`} onClick={() => { clickHandler(index) }} ref={(element) => { refBtns.current[index] = element; }}>
          {items[index]}
          <div className={styles.btn__hidden} ref={(element) => { refBtnsHiddens.current[index] = element; }}>
            <div className={styles.btn__inner}>
              {items[index]}
            </div>
          </div>
          <div className={styles.btn__border}></div>
        </div>
        array.push(btn);
      });
      setBtns(array);
    } else {
      setBtns([]);
    }
  }, [isMobile, items]);


  useEffect(() => {
    const inner = refInner.current;

    const burger = refBurger.current;
    const stages = document.querySelectorAll(`[data-stage]`);
    const headerTriggers = document.querySelectorAll(`[data-header-trigger]`);
    let offsetHeader = inner.offsetHeight + inner.getBoundingClientRect().top * 2;
    let wrap = refWrap.current;
    let wrapHeight = inner.offsetHeight;
    let offset = wrapHeight;
    const updateOffsetHeader = () => {
      offsetHeader = inner.offsetHeight + inner.getBoundingClientRect().top * 2;
    }
    refNav.current.classList.remove(styles.nav_hide);
    refLogo.current.classList.remove(styles.logo_hide);
    let options = {
      threshold: 0,
      rootMargin: `-${offset}px 0px 0px 0px`
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {

          refNav.current.classList.remove(styles.nav_hide);
          refLogo.current.classList.remove(styles.logo_hide);
        } else {
          refNav.current.classList.remove(styles.nav_hide);
          refLogo.current.classList.remove(styles.logo_hide);
          if (entry.target.getBoundingClientRect().bottom <= offset && !isMobile) {
            refNav.current.classList.add(styles.nav_hide);
            refLogo.current.classList.add(styles.logo_hide);
          }
        }
      })
    }, options);

    const triggerHandler = () => {
      let isTriggered = false;
      if (headerTriggers.length > 0) {
        headerTriggers.forEach(element => {
          if (element.getBoundingClientRect().top - inner.offsetHeight <= 0 && element.getBoundingClientRect().top + element.offsetHeight >= 0) {
            isTriggered = true;
          }
        });
      }
      if (isTriggered) {
        wrap.classList.add(styles.wrap_invert);
      } else {
        wrap.classList.remove(styles.wrap_invert);
      }
    }
    triggerHandler();
    document.addEventListener('scroll', triggerHandler);
    window.addEventListener('resize', triggerHandler);
    if (stages.length > 0) {
      observer.observe(stages[stages.length - 1]);
    }

    const scrollHandler = () => {
      let progress = 0;
      stages.forEach((element, i) => {
        let index = element.dataset.stage;
        if (document.querySelector(`[data-stage='${index}']`) !== null && refBtnsHiddens.current[index] !== undefined) {
          if (element.getBoundingClientRect().top < 0 && element.getBoundingClientRect().bottom - offsetHeader > 0) {
            let offsetHeight = document.querySelector(`[data-stage='${index}']`).offsetHeight;
            let offsetTop = document.querySelector(`[data-stage='${index}']`).offsetTop;
            let pageYOffset = window.pageYOffset;
            progress = ((pageYOffset - offsetTop) / (offsetHeight - offsetHeader)) * 100;
            if (progress >= 0 && progress <= 100) {
              if (refBtnsHiddens.current[index] !== null) {
                refBtnsHiddens.current[index].style.width = `${Math.round(progress)}%`
              }
            }
          } else {
            if (refBtnsHiddens.current[index] !== null) {
              if (i === stages.length - 1 && document.querySelector(`[data-stage='${stages.length - 1}']`).getBoundingClientRect().bottom + offsetHeader < 1) {
                // refBtnsHiddens.current[index].style.width = `100%`;
              } else {
                refBtnsHiddens.current[index].style.width = `0%`;
              }
            }
          }
        }
      });
    }
    if (isMobile) {
      burger.classList.add(styles.mobile);
    } else {
      burger.classList.remove(styles.mobile);
    }
    if (stages.length > 0) {
      scrollHandler();
      document.addEventListener('scroll', scrollHandler);
      window.addEventListener('resize', scrollHandler);
      window.addEventListener('resize', updateOffsetHeader);
    }
    return () => {
      document.removeEventListener('scroll', scrollHandler);
      document.removeEventListener('scroll', triggerHandler);
      window.removeEventListener('resize', triggerHandler);
      window.removeEventListener('resize', scrollHandler);
      window.removeEventListener('resize', updateOffsetHeader);
      if (stages.length > 0) {
        observer.unobserve(stages[stages.length - 1]);
      }
    }
  }, [items, isMobile]);


  useEffect(() => {
    const burger = refBurger.current;
    const menu = refMenu.current;
    const overlay = refOverlay.current;
    const handleEvent = (e) => {
      e.preventDefault();
      e.stopPropagation();
    }
    const toggleScroll = (bool) => {
      if (bool) {

        document.body.style.overflow = 'hidden';
        document.body.addEventListener('touchmove', handleEvent, { passive: false });
        document.body.addEventListener('wheel', handleEvent, { passive: false });
        document.body.addEventListener('scroll', handleEvent, { passive: false });

      } else {
        document.body.style.overflow = '';
        document.body.removeEventListener('touchmove', handleEvent, { passive: false });
        document.body.removeEventListener('wheel', handleEvent, { passive: false });
        document.body.removeEventListener('scroll', handleEvent, { passive: false });
      }
    }
    if (menuOpen) {
      burger.classList.add(styles.active);
      menu.classList.add(styles.active);
      overlay.classList.add(styles.active);
    } else {
      burger.classList.remove(styles.active);
      menu.classList.remove(styles.active);
      overlay.classList.remove(styles.active);
    }
    if (isMobile && menuOpen) {
      toggleScroll(true);
    } else {
      toggleScroll(false);
    }
    return () => {
      burger.classList.remove(styles.active);
      menu.classList.remove(styles.active);
      overlay.classList.remove(styles.active);
      toggleScroll(false);
    }
  }, [isMobile, menuOpen]);
  let linkClass = `${styles.link}`;
  let linkClassSmall = `${styles.link} ${styles.link_small}`;
  let linkClassActive = `${styles.link} ${styles.link_active}`;
  let linkClassSmallActive = `${styles.link} ${styles.link_small} ${styles.link_active}`;

  let wrapClass = `${styles.wrap}`;
  if (style !== '') {
    wrapClass += ` ${styles[`wrap_${style}`]}`;
  }
  if (currentPath === 'vacancy') {
    wrapClass += ` ${styles[`wrap_vacancy`]}`;
  }
  if (currentPath === 'vacancies') {
    wrapClass += ` ${styles[`wrap_vacancies`]}`;
  }

  const backParams = new URLSearchParams(searchParam);
  if (currentPath === 'internship') {
    backParams.set('tab', 'internships');
  } else {
    backParams.delete('tab');
  }
  const backSearch = backParams.toString() ? `?${backParams.toString()}` : '';

  return (
    <>
      <header className={wrapClass} ref={refWrap}>
        <div className="container">
          <div className={styles.inner} ref={refInner}>
            {(currentPath === 'vacancy' || currentPath === 'internship') ?
              <Link  to={{pathname: `/vacancies`, search: backSearch, hash:'list'}}  className={styles.back} onClick={(e)=>{e.target.style.opacity = 0}}>
                <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.4375 17.125L1.5625 9L8.4375 0.874998" stroke="#008359" strokeWidth="2" />
                </svg>
                {
                  isMobile? 'Вернуться к вакансиям' : 'Вернуться к списку вакансий'
                }

              </Link>
              : null}
              <Link to={{pathname: `/`, search: searchParam}} className={styles.logo} ref={refLogo}>
                <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.95026 20.333C7.95838 20.1865 7.93273 20.0401 7.87528 19.9052C7.81784 19.7702 7.73017 19.6503 7.61903 19.5547C7.53282 19.4508 7.42301 19.369 7.29882 19.3162C7.17462 19.2635 7.03963 19.2412 6.90512 19.2514C6.69828 19.2977 6.50361 19.3874 6.33398 19.5147L7.7104 20.8939C7.83214 20.7241 7.91237 20.5281 7.94458 20.3216" fill="#008359" />
                  <path d="M5.92269 22.3991C6.13131 22.3651 6.32786 22.2785 6.49382 22.1473L5.08886 20.791C4.96059 20.9602 4.8709 21.1556 4.82613 21.3633C4.80832 21.5027 4.82565 21.6443 4.87654 21.7753C4.92742 21.9062 5.01023 22.0223 5.11741 22.113C5.21543 22.2291 5.33954 22.3202 5.47953 22.3789C5.61952 22.4376 5.77138 22.4622 5.92269 22.4506" fill="#008359" />
                  <path d="M12.268 16.2983L10.3262 15.1938L11.4513 17.1167L12.268 16.2983Z" fill="#008359" />
                  <path d="M11.0918 25.5523H15.855L13.4734 23.1602L11.0918 25.5523Z" fill="#008359" />
                  <path d="M25.4949 15.8866V11.1138L23.1133 13.5002L25.4949 15.8866Z" fill="#008359" />
                  <path d="M3.6495 19.3258L4.92883 18.0439L5.2601 18.3587C5.49214 18.1125 5.7746 17.9196 6.08811 17.7931C6.40161 17.6667 6.73874 17.6097 7.07629 17.6262C7.72292 17.6436 8.33741 17.9125 8.78969 18.3759C9.02691 18.5956 9.21784 18.8608 9.35123 19.1556C9.48463 19.4505 9.55779 19.7691 9.56642 20.0927C9.55332 20.7918 9.29214 21.4633 8.82967 21.9869L9.13807 22.3017L7.89301 23.5492L7.55034 23.2173C7.00706 23.6815 6.31675 23.9371 5.60276 23.9384C4.98245 23.8896 4.40421 23.605 3.98645 23.1429C3.75607 22.9288 3.57227 22.6694 3.44648 22.3809C3.3207 22.0924 3.25564 21.781 3.25542 21.4662C3.28669 20.7962 3.53991 20.1559 3.97505 19.6463L3.6495 19.3258ZM6.36238 6.27794H14.6609L6.36238 14.5988V6.27794ZM16.5285 9.28812C16.7414 9.47443 16.9136 9.70271 17.0345 9.95872C17.1554 10.2147 17.2223 10.493 17.231 10.776C17.1749 11.4179 16.8693 12.0119 16.38 12.4299L15.7461 13.0823L17.0654 14.4043L15.7461 15.7033L11.5026 11.4513L13.4044 9.54564C13.8296 9.05473 14.4222 8.74046 15.0664 8.66433C15.3401 8.65423 15.6126 8.70492 15.8643 8.81276C16.1161 8.92061 16.341 9.08294 16.5228 9.28812M17.0483 5.89452L20.3894 7.8517L18.4361 4.49816L20.001 2.93012L24.2502 7.18786L23.108 8.33241L20.7892 6.04331L22.3027 8.90469L21.4174 9.78027L18.5617 8.2523L20.8863 10.5528L19.744 11.6974L15.5005 7.43966L17.0483 5.89452ZM14.0898 17.3572L13.3759 16.9509L12.0851 18.2442L12.4963 18.9539L11.2284 20.2186L8.37277 14.5473L9.69209 13.2254L15.352 16.0581L14.0898 17.3572ZM1.46777 25.5522H8.32136L13.4615 20.3559L18.6417 25.5522H25.4953V18.6849L20.3551 13.5344L25.4953 8.38392V1.5166H1.46777V25.5522Z" fill="#008359" />
                  <path d="M15.2779 11.5543C15.4184 11.4294 15.5113 11.2595 15.5406 11.0736C15.5488 10.966 15.5312 10.858 15.4895 10.7585C15.4478 10.659 15.3831 10.5709 15.3007 10.5014C15.2251 10.4185 15.1253 10.3616 15.0156 10.339C14.9058 10.3164 14.7917 10.3292 14.6896 10.3755C14.4886 10.4608 14.3076 10.5875 14.1585 10.7474L13.793 11.1194L14.7353 12.0637L15.2779 11.5543Z" fill="#008359" />
                  <path d="M0.656816 0.658118H26.2892V26.3419H0.656816V0.658118ZM0 26.9828H26.946V0H0V26.9828Z" fill="#008359" />
                </svg>

              </Link>
            <nav className={styles.nav} ref={refNav}>
              {btns}
            </nav>
            <div className={styles.burger} ref={refBurger} onClick={() => { setMenuOpen(!menuOpen) }}>
              <span></span>
              <span>
                <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.7501 6.75L7.25004 20.2501" stroke="white" strokeWidth="1.5" />
                  <path d="M20.7501 20.25L7.25004 6.74992" stroke="white" strokeWidth="1.5" />
                </svg>
              </span>
              <span></span>
            </div>

          </div>
        </div>
        <div className={styles.overlay} ref={refOverlay}></div>
        <div className={styles.menu} ref={refMenu}>
          {/* <div className={styles.menu__hidden}>
              <div className={styles.menu__bg}></div> */}
          <div className="container">
            <div className={styles.menu__inner}>
              <NavLink onClick={() => { setMenuOpen(false) }} to={{pathname:'/', search: searchParam}} className={({ isActive }) => isActive ? linkClassActive : linkClass}>Главная</NavLink>
              <NavLink onClick={() => { setMenuOpen(false) }} to={{pathname:'about', search: searchParam}} className={({ isActive }) => isActive ? linkClassActive : linkClass}>О Р-Фарм</NavLink>
              <span className={`${styles.link} ${styles.link_disable}`}>Истории сотрудников</span>
              <NavLink onClick={() => { setMenuOpen(false) }} to={{pathname:'story-svetlana', search: searchParam}} className={({ isActive }) => isActive ? linkClassSmallActive : linkClassSmall}>Светлана</NavLink>
              {/* <NavLink onClick={() => { setMenuOpen(false) }} to={{pathname:'story-alexandra', search: searchParam}} className={({ isActive }) => isActive ? linkClassSmallActive : linkClassSmall}>Александра</NavLink> */}
              <NavLink onClick={() => { setMenuOpen(false) }} to={{pathname:'story-evgenia', search: searchParam}} className={({ isActive }) => isActive ? linkClassSmallActive : linkClassSmall}>Евгения</NavLink>
              {/* <NavLink onClick={() => { setMenuOpen(false) }} to={{pathname:'story-felix', search: searchParam}} className={({ isActive }) => isActive ? linkClassSmallActive : linkClassSmall}>Феликс</NavLink> */}
              <NavLink onClick={()=>{setMenuOpen(false)}} to={{pathname:'story-dmitry', search: searchParam}} className={({ isActive }) => isActive ? linkClassSmallActive : linkClassSmall}>Дмитрий</NavLink>
              <NavLink onClick={()=>{setMenuOpen(false)}} to={{pathname:'story-ekaterina', search: searchParam}} className={({ isActive }) => isActive ? linkClassSmallActive : linkClassSmall}>Екатерина</NavLink>
              <NavLink onClick={() => { setMenuOpen(false) }} to={{pathname:'vacancies', search: searchParam}} className={({ isActive }) => isActive ? linkClassActive : linkClass}>Вакансии</NavLink>
              {/* <a href={`https://spb.hh.ru/employer/8121`} target='_blank'  rel="noreferrer" onClick={()=>{setMenuOpen(false)}}  className={linkClass}>Вакансии</a> */}
            </div>
          </div>
          {/* </div> */}

        </div>
      </header>
    </>
  );

}

export default Header;
